import { render, staticRenderFns } from "./CraftCourse.vue?vue&type=template&id=2949d7cc"
import script from "./CraftCourse.vue?vue&type=script&lang=js"
export * from "./CraftCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports